import { z } from 'zod';

// =========================================================
// WAREHOUSE + WAREHOUSE ZONE
// Riferimento: piano feasibility Fase 1-4 + ADR 0007 SAP Beta.
// 2 zone attive (PRINCIPALE + PRODUZIONE). Le altre 3 sono placeholder Fase 5.
// =========================================================

export const warehouseZoneCodeSchema = z.enum([
  'RICEVIMENTO_QUARANTENA',
  'PRINCIPALE',
  'PRODUZIONE',
  'PRODOTTO_FINITO',
  'DA_RESTITUIRE',
]);
export type WarehouseZoneCode = z.infer<typeof warehouseZoneCodeSchema>;

export const warehouseZoneResponseSchema = z.object({
  id: z.string().uuid(),
  warehouseId: z.string().uuid(),
  code: warehouseZoneCodeSchema,
  name: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type WarehouseZoneResponse = z.infer<typeof warehouseZoneResponseSchema>;

export const warehouseResponseSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  country: z.string().length(2),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  zones: z.array(warehouseZoneResponseSchema).optional(),
});
export type WarehouseResponse = z.infer<typeof warehouseResponseSchema>;

export const warehouseListResponseSchema = z.object({
  items: z.array(warehouseResponseSchema),
});
export type WarehouseListResponse = z.infer<typeof warehouseListResponseSchema>;

export const WAREHOUSE_ZONE_CODE_LABELS_IT: Record<WarehouseZoneCode, string> = {
  RICEVIMENTO_QUARANTENA: 'Ricevimento / Quarantena',
  PRINCIPALE: 'Magazzino principale',
  PRODUZIONE: 'Ciclo di produzione',
  PRODOTTO_FINITO: 'Prodotto finito',
  DA_RESTITUIRE: 'Da restituire',
};
